export const cloudinaryRealEstatePhotos = [
  {
    publicId: "realestate/iwpmj5lx5j0ynokjbxp5",
    width: 750,
    height: 500,
  },
  {
    publicId: "realestate/xd6yuaznhinze4texuaf",
    width: 750,
    height: 500,
  },
  {
    publicId: "realestate/rp4buzyjnx9zrs9exuda",
    width: 750,
    height: 500,
  },
  {
    publicId: "realestate/otr4tr6ym1xjfwmyziso",
    width: 750,
    height: 500,
  },
  {
    publicId: "realestate/uoo9qtcyvrvyfmprfjfq",
    width: 750,
    height: 500,
  },
  {
    publicId: "realestate/ljtwkciqvi6hgmkdsqrq",
    width: 750,
    height: 500,
  },
  {
    publicId: "realestate/y6bwifyq07nlqeycluv5",
    width: 750,
    height: 500,
  },
  {
    publicId: "realestate/vmfkzhexdk2i1okxskiw",
    width: 750,
    height: 500,
  },

  {
    publicId: "realestate/mwhzxp3qh8yflesmgqmh",
    width: 750,
    height: 500,
  },
  {
    publicId: "realestate/kcmc2ca16iuamvdlxh7b",
    width: 750,
    height: 500,
  },
  {
    publicId: "realestate/sbxb9mkszfhs8elcaggf",
    width: 750,
    height: 500,
  },
  {
    publicId: "realestate/osrsauzcppaojw5ce0xn",
    width: 750,
    height: 500,
  },
  {
    publicId: "realestate/viyrvbrzwrhvldnicfr5",
    width: 750,
    height: 500,
  },
  {
    publicId: "realestate/nuiwlwh7q1brq0ljqlqx",
    width: 750,
    height: 500,
  },
  {
    publicId: "realestate/nvkeh1w2pfwqey9tbfzh",
    width: 750,
    height: 500,
  },
  {
    publicId: "realestate/n2efxtagvwep38g1f8cg",
    width: 750,
    height: 500,
  },
  {
    publicId: "realestate/ojuvz8nettaearjopely",
    width: 750,
    height: 500,
  },
  {
    publicId: "realestate/dlcrpkmqrk471wfbrv0j",
    width: 750,
    height: 500,
  },
  {
    publicId: "realestate/xonujkzlqrf5sbcl07ug",
    width: 750,
    height: 500,
  },
  {
    publicId: "realestate/tzud1lydais40ska8hhc",
    width: 750,
    height: 500,
  },
  {
    publicId: "realestate/igith1jldyolqvakvoet",
    width: 750,
    height: 500,
  },
  {
    publicId: "realestate/rclihroocbwacpmapov6",
    width: 750,
    height: 500,
  },
  {
    publicId: "realestate/qhiv6cdaxtq82usn7ltw",
    width: 750,
    height: 500,
  },
  {
    publicId: "realestate/buqaadfetyrkzlaelvnp",
    width: 750,
    height: 500,
  },
  {
    publicId: "realestate/wezbzumgscr1lrbbfpfd",
    width: 750,
    height: 500,
  },
  {
    publicId: "realestate/y2u7avr4x4epjsmidunk",
    width: 750,
    height: 500,
  },
  {
    publicId: "realestate/a3uy3knlgsg6gu2tusip",
    width: 750,
    height: 500,
  },
];
